<div class="cookie-banner" *ngIf="showConsent">
  <p>
    We use cookies to improve your experience and analyze site usage.
    By continuing, you agree to our
    <a routerLink="/privacy">Privacy Policy</a>.
  </p>
  <div class="cookie-actions">
    <button mat-stroked-button class="decline-btn" (click)="decline()">Decline</button>
    <button mat-flat-button color="accent" (click)="accept()">Accept</button>
  </div>
</div>
